import { Green } from "src/styles/color";

const Success = ({ size = 24, color = Green }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_785_1298)">
      <circle cx="20" cy="20" r="20" fill={color} />
      <path
        d="M31.3881 14.6882C32.204 13.8438 32.204 12.4777 31.3881 11.6333C30.5723 10.7889 29.2525 10.7889 28.4367 11.6333L16.6977 23.7808L11.5633 18.4722C10.7475 17.6278 9.42769 17.6278 8.61187 18.4722C7.79604 19.3166 7.79604 20.6827 8.61187 21.5271L15.222 28.366C15.6285 28.7896 16.1659 29 16.6977 29C17.2323 29 17.7669 28.7896 18.1734 28.366L31.3881 14.6882Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_785_1298">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Success;
